import { apiResponse, ApiService } from '@stores/index';

export class GroupParticipantsStore {
  constructor(private readonly api: ApiService = new ApiService()) {}

  async readByGroupId(groupId: number) {
    try {
      const result = await this.api.get(`Cohort/${groupId}/participants`);
      return apiResponse.Success(result);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }
}
